
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/backend-i-panele-administracyjne",
      function () {
        return require("private-next-pages/backend-i-panele-administracyjne.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/backend-i-panele-administracyjne"])
      });
    }
  